import {BirthdayMember} from '../../types/birthdays'
import './BirthdayTooltip.css'

interface BirthdayTooltipProps {
  birthday: BirthdayMember
}

export const BirthdayTooltip = ({birthday}: BirthdayTooltipProps) => {
  const fullName = `${birthday.firstName} ${birthday.middleName || ''} ${birthday.lastName} ${
    birthday.secondLastName || ''
  }`.replace(/\s+/g, ' ')

  return (
    <div className='birthday-tooltip'>
      <div className='birthday-tooltip-content'>
        <div className='birthday-tooltip-name'>{fullName}</div>
        <div className='birthday-tooltip-details'>
          <div className='birthday-tooltip-row'>
            <span className='birthday-tooltip-label'>Agent:</span>
            <span className='birthday-tooltip-value'>{birthday.agentName}</span>
          </div>
          <div className='birthday-tooltip-row'>
            <span className='birthday-tooltip-label'>Age:</span>
            <span className='birthday-tooltip-value'>{birthday.age}</span>
          </div>
        </div>
      </div>
    </div>
  )
}
